import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PrimaryButton } from './PrimaryButton';
import { formatMicrograms } from '../../utils/rekovelleDose';
import { penClipUrl } from '../../data/teaser';
type PenScreenProps = {
  dose: number;
  onNext: () => void;
};
type ClipState = 'loading' | 'ready' | 'error';
export function PenScreen({
  dose,
  onNext
}: PenScreenProps) {
  const [clip, setClip] = useState<ClipState>('loading');
  return <div className="flex h-full flex-col" data-id="element-178" data-mp="157akzgdgddr9">
      <div className="relative min-h-0 flex-1 overflow-hidden rounded-3xl bg-ink" data-id="element-179" data-mp="158lpjieq2pjf">
        {clip !== 'error' && <video src={penClipUrl} autoPlay muted loop playsInline preload="auto" onCanPlay={() => setClip('ready')} onError={() => setClip('error')} className="absolute inset-0 h-full w-full object-cover" aria-label="Short clip: REKOVELLE pen close-up, dose being set, brief administration moment" data-id="element-180" data-mp="113vv7xzppj0m" />}
        <AnimatePresence data-id="element-181" data-mp="1xfjyik54ndea">
          {clip === 'loading' && <motion.div key="loading" className="absolute inset-0 flex items-center justify-center" exit={{
          opacity: 0
        }} transition={{
          duration: 0.2
        }} data-id="element-182" data-mp="1xf0p5rtjlxbv">
              <span className="h-6 w-6 animate-spin rounded-full border-2 border-white/25 border-t-white" aria-label="Loading clip" data-id="element-183" data-mp="19q7qhnljdbdk" />
            </motion.div>}
        </AnimatePresence>
        {clip === 'error' && <div className="absolute inset-0 flex items-center justify-center p-6 text-center text-[13px] text-white/70" data-id="element-184" data-mp="10qcan5h1cs77">
            The pen clip couldn’t load. The dose is still set for this patient.
          </div>}
        <div className="absolute bottom-4 left-4 rounded-full bg-white/95 px-3.5 py-2 shadow-[0_4px_16px_rgba(0,0,0,0.2)]" data-id="element-185" data-mp="qsoecb3s7cmx">
          <p className="font-mono text-[9.5px] tracking-[0.12em] text-graphite" data-id="element-186" data-mp="vsj58enk427z">STARTING DOSE</p>
          <p className="text-[18px] font-semibold leading-tight tabular-nums tracking-[-0.02em] text-accent" data-id="element-187" data-mp="2xhqfh6egug5d">{formatMicrograms(dose)}</p>
        </div>
      </div>

      <p className="mt-5 text-[28px] font-semibold leading-[1.06] tracking-[-0.03em] text-ink" data-id="element-188" data-mp="2ooderia5ua8q">
        Calculated for the patient.
        <br data-id="element-189" data-mp="2jq23d347vroe" />
        <span className="text-graphite" data-id="element-190" data-mp="2jme8o0n1cz83">Set on the pen.</span>
      </p>

      <div className="mt-5" data-id="element-191" data-mp="3gdycxo18lmq4">
        <PrimaryButton onClick={onNext} data-id="element-192" data-mp="3gc5eux4owatq">CONTINUE</PrimaryButton>
      </div>
    </div>;
}